import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useRecurrenceData } from "hooks/configs/recurence/useRecurrenceData";
import { useRecurrenceForm } from "hooks/configs/recurence/useRecurrenceForm";
import { PermissionGuard } from "components/configs/recurence/PermissionGuard";
import { PageHeader } from "components/configs/recurence/PageHeader";
import { RecurrenceForm } from "components/configs/recurence/RecurrenceForm";
import { LoadingSpinner } from "components/configs/recurence/LoadingSpinner";
import { ErrorMessage } from "components/configs/recurence/ErrorMessage";

const RecurencePage = (props) => {
  const { t, ready } = useTranslation();

  useEffect(() => {
    document.title = ready ? t("Satis client - Paramètre récurence") : "";
  }, [ready, t]);

  const { data, isLoading, error } = useRecurrenceData();
  const {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  } = useRecurrenceForm(data);

  return (
    <PermissionGuard userPermissions={props.userPermissions} ready={ready}>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <PageHeader t={t} />

        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="row">
            <div className="col">
              <div className="kt-portlet">
                <div className="kt-portlet__head">
                  <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                      {t("Alerte récurrence des réclamations")}
                    </h3>
                  </div>
                </div>

                {error && <ErrorMessage error={error} t={t} />}

                {isLoading ? (
                  <LoadingSpinner t={t} />
                ) : (
                  <RecurrenceForm
                    formData={formData}
                    errors={errors}
                    onFieldChange={updateField}
                    onSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    t={t}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(RecurencePage);
